import {
  ADMIN_PAGE_GET_REQUEST,
  ADMIN_PAGE_GET_SUCCESS,
  ADMIN_PAGE_GET_FAIL,
  ADMIN_PAGES_GET_REQUEST,
  ADMIN_PAGES_GET_SUCCESS,
  ADMIN_PAGES_GET_FAIL,
  ADMIN_PAGE_UPDATE_REQUEST,
  ADMIN_PAGE_UPDATE_SUCCESS,
  ADMIN_PAGE_UPDATE_FAIL,
  ADMIN_PAGE_CREATE_REQUEST,
  ADMIN_PAGE_CREATE_SUCCESS,
  ADMIN_PAGE_CREATE_FAIL,
  ADMIN_PAGE_GENERATE_REQUEST,
  ADMIN_PAGE_GENERATE_SUCCESS,
  ADMIN_PAGE_GENERATE_FAIL,
  ADMIN_PAGE_GENERATE_RESET,
  ADMIN_PAGE_PRESET_GET_REQUEST,
  ADMIN_PAGE_PRESET_GET_SUCCESS,
  ADMIN_PAGE_PRESET_GET_FAIL,
  ADMIN_PAGE_VERSION_CHANGE_REQUEST,
  ADMIN_PAGE_VERSION_CHANGE_SUCCESS,
  ADMIN_PAGE_VERSION_CHANGE_FAIL,
  ADMIN_PAGE_VERSION_GET_REQUEST,
  ADMIN_PAGE_VERSION_GET_SUCCESS,
  ADMIN_PAGE_VERSION_GET_FAIL,
  ADMIN_PAGE_VERSIONS_GET_REQUEST,
  ADMIN_PAGE_VERSIONS_GET_SUCCESS,
  ADMIN_PAGE_VERSIONS_GET_FAIL,
} from "./pageTypes";

export const pageReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    // GET PAGES
    case ADMIN_PAGES_GET_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGES_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        pages: action.payload.pages,
        total: action.payload.total,
      };

    case ADMIN_PAGES_GET_FAIL:
      return { ...state, loading: false, error: action.payload };

    // GET PAGE
    case ADMIN_PAGE_GET_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        page: action.payload,
      };

    case ADMIN_PAGE_GET_FAIL:
      return { ...state, loading: false, error: action.payload };

    // UPDATE PAGE
    case ADMIN_PAGE_UPDATE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        page: action.payload,
      };

    case ADMIN_PAGE_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // GET PAGES
    case ADMIN_PAGE_GENERATE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_GENERATE_SUCCESS:
      return {
        ...state,
        loading: false,
        pagesToGenerate: action.payload,
      };

    case ADMIN_PAGE_GENERATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_PAGE_GENERATE_RESET:
      return { ...state, loading: false, pagesToGenerate: undefined };

    // CREATE PAGE
    case ADMIN_PAGE_CREATE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        page: action.payload,
      };

    case ADMIN_PAGE_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // GET PRESETS
    case ADMIN_PAGE_PRESET_GET_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_PRESET_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        presets: action.payload,
      };

    case ADMIN_PAGE_PRESET_GET_FAIL:
      return { ...state, loading: false, error: action.payload };

    //  VERSION MANAGEMENT
    case ADMIN_PAGE_VERSION_CHANGE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_VERSION_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        page: action.payload,
      };

    case ADMIN_PAGE_VERSION_CHANGE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // version
    case ADMIN_PAGE_VERSION_GET_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_VERSION_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        page: action.payload,
      };

    case ADMIN_PAGE_VERSION_GET_FAIL:
      return { ...state, loading: false, error: action.payload };

    // versions
    case ADMIN_PAGE_VERSIONS_GET_REQUEST:
      return { ...state, loading: true };

    case ADMIN_PAGE_VERSIONS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        pageVersions: action.payload,
      };

    case ADMIN_PAGE_VERSIONS_GET_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
